import { render, staticRenderFns } from "./WorkbenchTopbar.vue?vue&type=template&id=767438d8&scoped=true&"
import script from "./WorkbenchTopbar.vue?vue&type=script&lang=js&"
export * from "./WorkbenchTopbar.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchTopbar.vue?vue&type=style&index=0&id=767438d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767438d8",
  null
  
)

export default component.exports